// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"291":"7f961367","884":"65a50c56"}[chunkId] + ".css";
};